export const STATUS_CHAT = {
  AG_ATENDIMENTO: 1,
  ATENDENDO: 2,
  FINALIZADO: 3,
  TRANSFERENCIA: 4,
  ERRO: 5,
};

export const STATUS_SITUACAO_CHAT = {
  FINALIZADO_INATIVIDADE: 8,
  FINALIZADO_EXPEDIENTE: 9,
  FINALIZADO_OPERADOR: 11,
};

export const TIPO_ENCERRAMENTO_CHAT = {
  INATIVIDADE: 'finaliza_chat_inatividade',
  OPERADOR: 'finaliza_chat_operador',
  EXPEDIENTE: 'finaliza_chat_expediente',
  CHAT_FINALIZADO: 'chat_finalizado',
};
